var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payMentDetails" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("data.split_transaction_detail"),
            visible: _vm.dialogTableVisible,
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "total" }, [
            _c("div", { staticClass: "total-item" }, [
              _c("div", { staticClass: "total-title" }, [
                _vm._v(_vm._s(_vm.$t("data.split_amount")) + ":"),
              ]),
              _c("div", { staticClass: "total-num" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$store.getters.currency) +
                    " " +
                    _vm._s(
                      _vm._f("toDivideWithDot")(_vm.merchantInfo.split_amount)
                    )
                ),
              ]),
            ]),
            _c("div", { staticClass: "line" }),
            _c("div", { staticClass: "total-item" }, [
              _c("div", { staticClass: "total-title" }, [
                _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
              ]),
              _c("div", { staticClass: "total-num" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$store.getters.currency) +
                    " " +
                    _vm._s(
                      _vm._f("toDivideWithDot")(_vm.merchantInfo.split_fee)
                    )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.timeline")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("components.create_time"))),
            ]),
            _c("span", { staticClass: "content-blue" }, [
              _vm._v(_vm._s(_vm.$t("merchantAccount.complete_time"))),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c(
              "span",
              { staticClass: "item-left", staticStyle: { color: "#4B5567" } },
              [_vm._v(_vm._s(_vm.merchantInfo.transaction_create_time))]
            ),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_return_time)),
            ]),
          ]),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.description")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.split_transaction_no"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.split_payment_no)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.split_detail_transaction_no"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.detail_no)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.transaction_no"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.transaction_id)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.split_merchant"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(_vm.merchantInfo.send_merchant_no) +
                  "-" +
                  _vm._s(_vm.merchantInfo.send_merchant_name)
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.receiver_type"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(_vm.getReceiverTypeLabel(_vm.merchantInfo.receiver_type))
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.receiver_account"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.receiver_account)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.receiver_name"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.receiver_name)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.description"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.description)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("data.fail_reason"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.merchantInfo.failed_reason)),
            ]),
          ]),
          _c(
            "el-tag",
            {
              staticClass: "payin-status tag-custom",
              attrs: {
                type: _vm.getSplitStatusMapType(
                  _vm.merchantInfo.split_detail_status
                ),
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.getSplitStatusMapLabel(
                      _vm.merchantInfo.split_detail_status
                    )
                  )
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }